// import HeroSection from "./Hero";
import ImageGalleryLayout from "./ImageGalleryLayout";

const ImageGalleryWrapper = () => {
  return (
    <main className="relative w-full overflow-hidden">

      {/* Medical textured background */}
      <div
        aria-hidden
        className="pointer-events-none absolute inset-0 bg-medical-texture opacity-[0.35]"
      />

      {/* Page container */}
      <div
        className="
          relative mx-auto 
         
        "
      >
        {/* Sections with controlled spacing */}
        <div className="space-y-12 sm:space-y-16 lg:space-y-20">
          {/* <HeroSection /> */}
          <ImageGalleryLayout />
        </div>
      </div>

    </main>
  );
};

export default ImageGalleryWrapper;
